import request from '../../src/state/modules/axios'

export function getPaymentTypes(){
    return request({
        url: '/api/payment-types',
        method: 'get',
    })
}

export function getPaymentById(data){
    return request({
        url: `/api/payment-types/${data.id}`,
        method: 'get',
    })
}

export function addPaymentTypes(data){
    return request({
        url: '/api/payment-types',
        method: 'post',
        data,
    })
}

export function editPaymentTypes(data){
    return request({
        url: `/api/payment-types/${data.id}`,
        method: 'put',
        data,
    })
}

export function deletePaymentTypes(data){
    return request({
        url: `/api/payment-types/${data.id}`,
        method: 'delete'
    })
}